import Schema from 'AppReact/schema';
import { orderEvent } from 'types';

export default {
  order_event: Schema(orderEvent, 'object', { defaultValue: {} }),
  isOpen: Schema('boolean', 'primitive', { defaultValue: false }),
  translation: Schema("string", "primitive", { defaultValue: '' }),
  translated: Schema("boolean", "primitive", { defaultValue: false }),
  totalTimeTracked: Schema("integer", "primitive", { defaultValue: 0 }),
};
